
export default {
  namespaced: true,
  state: {
    view: 'list',
    selectedTab: 0,
    details: {
      customerName: true,
      shippingMethod: true,
      paymentMethod: false,
      customerPhone: false,
      customerEmail: false,
      itemsOrdered: true,
      source: false,
      amountPaid: true,
      address: false,
      orderMessage: false,
      extraInfo: false,
      scheduledDateTime: true,
      remarks: false
    },
    filters: {
      sort: null,
      date: null,
      range: null,
      processing: null,
      ready: null,
      shipping: null,
      payment: null,
      source: null
    },
    search: null,
    zoneCount: 0,
    leads: [],
    leadsVersion: 0,
    shipments: {
      easyparcel: false,
      zepto: false,
      lalamove: false,
      yscourier: false,
      yslocaldelivery: false
    }
  },
  mutations: {
    recoverOrderViewDetails (state) {
      let orderViewDetails = localStorage.getItem('yz_order_view')
      if (orderViewDetails) {
        orderViewDetails = JSON.parse(orderViewDetails)
        state.view = orderViewDetails.view
        state.details = orderViewDetails.details
      }
    },
    setOrderView (state, view) {
      state.view = view
      const data = {
        view: view,
        details: state.details
      }
      localStorage.setItem('yz_order_view', JSON.stringify(data))
    },
    setOrderDetails (state, details) {
      state.details = details
      const data = {
        view: state.view,
        details: details
      }
      localStorage.setItem('yz_order_view', JSON.stringify(data))
    },
    setSelectedTab (state, tab) {
      state.selectedTab = tab
    },
    setZoneCount (state, count) {
      state.zoneCount = count
    },
    setFilters (state, filters) {
      state.filters = filters
    },
    setFilterObject (state, data) {
      state.filters[data.key] = data.value
    },
    setSearch (state, data) {
      state.search = data
    },
    resetFilters (state) {
      state.filters = {
        sort: null,
        date: null,
        range: null,
        processing: null,
        ready: null,
        shipping: null,
        payment: null,
        source: null
      }
    },
    resetSearch (state) {
      state.search = null
    },
    addLead (state, item) {
      state.leads.push(item)
    },
    deleteLead (state, item) {
      state.leads = state.leads.filter(f => f.id !== item.id)
    },
    resetLeads (state, updateVersion) {
      state.leads = []
      if (updateVersion) {
        state.leadsVersion = state.leadsVersion + 1
      }
    },
    replaceLeads (state, leads) {
      state.leads = [ ...leads ]
    },
    setShipments (state, data) {
      state.shipments = data
    },
  },
  getters: {
    getOrderView (state) {
      return state.view
    },
    getOrderDetails (state) {
      return state.details
    },
    getZoneCount (state) {
      return state.zoneCount
    },
    getFilters (state) {
      return state.filters
    },
    getSearch (state) {
      return state.search
    },
    getSelectedLeads (state) {
      return state.leads
    },
    getShipments (state) {
      return state.shipments
    }
  }
}